module.exports = __webpack_public_path__ + "static/media/Renewal.0b0177e1.jpg";